// reducers/pubsub/disable.js

export function disableHasErrored(state = false, action) {
  switch (action.type) {
    case 'DISABLE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function disableIsLoading(state = false, action) {
  switch (action.type) {
    case 'DISABLE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function disable(state = [], action) {
  switch (action.type) {
    case 'DISABLE_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}